function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n   padding: 3rem 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   position: relative;\n   top: -3rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Card } from './Card';
import { InnerContentWrapper } from './InnerContentWrapper';
import { OuterContentWrapper } from './OuterContentWrapper';
var Outer = styled(OuterContentWrapper)(_templateObject());
var TssCard = styled(Card)(_templateObject2());

var PageContent = function PageContent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(TssCard, null, /*#__PURE__*/React.createElement(InnerContentWrapper, null, children)));
};

export { PageContent };